
import { defineComponent, ref, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import { get_customer_detail, query_customer_remain_info_list } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import moment from 'moment';
export default defineComponent({
  name: 'Printcustomerremainmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],

  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const loading = ref(false);
    const dataSource: Array<any> = reactive([]);
    const state = reactive({
      time:moment().format('YYYY-MM-DD HH:mm'),
      customerObj: {
        code: '',
        name: '',
        phone: '',
        adviser__name: '',
        wallet: {
          real_money: 0,
          void_money: 0,
        },
      },
      columns: [
        {
          title: '序号',
          dataIndex: '_index',
          key: '_index',
          width: 50,
        },
        {
          title: '项目',
          dataIndex: 'project_name',
          key: 'project_name',
          width: 200,
        },
        {
          title: '余次',
          dataIndex: 'now_num',
          key: 'now_num',
          width: 50,
        },
        {
          title: '到期时间',
          dataIndex: 'end_date',
          key: 'end_date',
          width: 150,
          slots: { customRender: 'end_date' },
        },
      ],
      dataSource: dataSource,
    });
    onMounted(() => {
      loadData();
    });

    const loadData = () => {
      get_customer_detail({
        org_id: current_org.id,
        customer_id: props.obj.customer_id,
      }).then((res: any) => {
        Object.assign(state.customerObj, res.customer);
        Object.assign(state.customerObj.wallet, res.customer_wallet);
      });
      query_customer_remain_info_list({
        org_id: current_org?.id,
        customer_ids: props.obj.customer_id,
        shop_id: current_shop?.id,
        pageSize:4000,
      }).then((res: any) => {
        dataSource.length = 0;
        res.data.map((item: any) => {
          dataSource.push(item);
        });
        message.success('查询成功');
      });
    };

    const handleCancel = () => {
      emit('cancel');
    };
    const handleQuery = () => {
      loadData();
    };
    return {
      message,
      loading,
      state,
      handleCancel,
      handleQuery,
    };
  },
});
